import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import '../../scss/components/_stories-widget.scss';

export class StoriesWidget {
  constructor (target) {
    this.section = target;
  }

  init () {
    if (!this.section || CMS.editMode) {
      return;
    }

    const config = {
      autoHeight: false,
      pagination: {
        el: this.section.querySelector('.swiper-pagination'),
        clickable: true
      },
      modules: [Pagination],
    };

    const sliderElement = this.section.querySelector('.swiper')

    new Swiper(sliderElement, config);

    this.loading(false);
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }
}
